import React from 'react';
import { Notifications } from '@mantine/notifications';
import { useIsPhone } from '@/hooks/use.responsive';

const NotificationsHost: React.FC = () => {
    const phone = useIsPhone();
    return <Notifications position={phone ? 'bottom-center' : 'top-right'} limit={5} />;
};

export default NotificationsHost;
